<template>
    <div>
           <h1 class="text-center mb-4"> Opciones formularios</h1>
           <div>
      <form-discapacidad />

      <form-establecimiento />


      <form-etmitrimestre/>

      <form-etmivacuna/>

      <form-vacunatipomujer/>

      <form-vacunadosismujer/>

      <form-vacunanombremujer/>


      <form-vacunaclasificacionnino/>

      <form-vacunatiponino/>

      <form-vacunadosisnino/>

      <form-tamizajeclasificacionnino/>




      
    </div>
   
    </div>
</template>

<script>
export default {
  name: 'Formularios',
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    const isAdmin = this.currentUser && this.currentUser.roles.includes('ROLE_ADMINISTRADOR');
    if (!isAdmin) {
      this.$router.push('/login');
    } 
  }
};
</script>

<style lang="scss" scoped>

</style>